export const ACORN_PARSE_OPTIONS = {
  allowReturnOutsideFunction: true,
  locations: true,
  ecmaVersion: 2020 as const,
};
